import axios from 'axios'
import { encrypt1, encrypt2, encryptMd5, encryptBase64, encryptHex } from '@/assets/js/Encrypt'
import { Message } from 'element-ui'

const systemParams = {
  token: Wiz.AuthHooks.GetToken(),
  userId: Wiz.AuthHooks.GetUserInfo()?.profile.sub,
  account: Wiz.AuthHooks.GetUserInfo()?.profile.name,
}
/**
 * @description 获取加密参数内容
 * @param data 登录参数配置
 */
export function getEncryptValue(data, value) {
  const { type, key, inEnc, mode, pad, iv, outEnc, block } = data
  if (['AES', 'DES', 'TripleDES'].includes(data.type)) {
    return encrypt1(type, value, key, inEnc, outEnc, mode, pad, iv, block)
  }
  if (['RC4', 'Rabbit'].includes(data.type)) {
    return encrypt2(type, value, key, inEnc, outEnc)
  }
  if (data.type === 'MD5') {
    return encryptMd5(value, outEnc)
  }
  if (data.type === 'Base64') {
    return encryptBase64(value)
  }
  if (data.type === 'Hex') {
    return encryptHex(value)
  }
  return value
}
/**
 * @description 获取参数内容
 * @param data 登录参数配置
 * @param ssoInfo 应用单点登录配置
 */
export function getFieldValue(data, ssoInfo) {
  let val = ''
  switch (data.fieldsType) {
    case '系统参数':
      val = systemParams[data.fieldsValue]
      break
    case '常量':
      val = data.fieldsValue
      break
    case '账户':
      val = ssoInfo.accountValue
      break
    case '密码':
      val = ssoInfo.pwdValue
      break
    default:
      break
  }
  return getEncryptValue(data, val)
}
/**
 * @description form表单提交登录
 * @param appConfig 应用配置
 * @param ssoInfo 应用单点登录配置
 */
export function createFormSubmit(appConfig, ssoInfo) {
  const methodType = {
    0: 'get',
    1: 'post',
    2: 'get',
    3: 'post'
  }
  let inputHtml = ''
  const params = appConfig.moreParamSetting ? JSON.parse(appConfig.moreParamSetting) : []
  params.forEach((item) => {
    const val = getFieldValue(item, ssoInfo)
    inputHtml += `<input type="hidden" name="${item.fieldsName}" value="${val}">`
  })
  const newWindow = window.open('')
  const html = `<html>
    <head>
      <title>${appConfig.name}</title>
    </head>
    <body>
      <form action="${appConfig.loginUrl}" method="${methodType[appConfig.postType]}" name="ssoform" id="ssoform">
        ${inputHtml}
      </form>
    </body>
    <script>
      document.getElementById('ssoform').submit()
    </script>
  </html>`
  newWindow.document.write(html)
}
/**
 * @description 单点登录
 * @param appConfig 应用配置
 * @param ssoInfo 应用单点登录配置
 */
export function ssoLogin(appConfig, ssoInfo) {
  if ([2, 3].includes(appConfig.postType)) {
    createFormSubmit(appConfig, ssoInfo)
    return
  }
  const headers = {}
  const query = {}
  let body = null
  const params = appConfig.moreParamSetting ? JSON.parse(appConfig.moreParamSetting) : []
  params.forEach((item) => {
    const val = getFieldValue(item, ssoInfo)
    if (item.postType === 'header') {
      headers[item.fieldsName] = val
    } else if (item.postType === 'url') {
      query[item.fieldsName] = val
    } else if (item.postType === 'form') {
      if (body === null) {
        body = new FormData()
      }
      body.append(item.fieldsName, val)
    } else {
      if (body === null) {
        body = {}
      }
      body[item.fieldsName] = val
    }
  })
  axios({
    method: appConfig.postType === 0 ? 'get' : 'post',
    headers,
    params: query,
    data: body,
    url: appConfig.loginUrl
  }).then((res) => {
    if (item.redirectURL) {
      window.open(item.redirectURL)
    }
  }).catch((err) => {
    Message.error(`${err.response.status}:${err.response.statusText}`)
  })
}
export default {
  ssoLogin,
  getFieldValue,
}
